import { render, staticRenderFns } from "./SettingsNav.vue?vue&type=template&id=71f3597a&scoped=true&"
import script from "./SettingsNav.vue?vue&type=script&lang=js&"
export * from "./SettingsNav.vue?vue&type=script&lang=js&"
import style0 from "./SettingsNav.vue?vue&type=style&index=0&id=71f3597a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f3597a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f3597a')) {
      api.createRecord('71f3597a', component.options)
    } else {
      api.reload('71f3597a', component.options)
    }
    module.hot.accept("./SettingsNav.vue?vue&type=template&id=71f3597a&scoped=true&", function () {
      api.rerender('71f3597a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nav/settings/SettingsNav.vue"
export default component.exports